export type Color = { r: number; g: number; b: number; a: number };
export const positive700 = { r: 40, g: 129, b: 87, a: 255 } as const;
export const positive500 = { r: 68, g: 197, b: 137, a: 255 } as const;
export const positive300 = { r: 208, g: 240, b: 225, a: 255 } as const;
export const positive100 = { r: 243, g: 251, b: 248, a: 255 } as const;
export const notice900 = { r: 153, g: 107, b: 0, a: 255 } as const;
export const notice700 = { r: 255, g: 177, b: 0, a: 255 } as const;
export const notice300 = { r: 255, g: 239, b: 204, a: 255 } as const;
export const notice100 = { r: 255, g: 247, b: 227, a: 255 } as const;
export const negative700 = { r: 224, g: 0, b: 56, a: 255 } as const;
export const negative300 = { r: 255, g: 219, b: 228, a: 255 } as const;
export const negative100 = { r: 255, g: 245, b: 248, a: 255 } as const;
export const informative700 = { r: 0, g: 120, b: 153, a: 255 } as const;
export const informative100 = { r: 220, g: 244, b: 250, a: 255 } as const;
export const maybeBlue900 = { r: 0, g: 81, b: 102, a: 255 } as const;
export const maybeBlue700 = { r: 0, g: 128, b: 163, a: 255 } as const;
export const maybeBlue500 = { r: 0, g: 173, b: 219, a: 255 } as const;
export const maybeBlue300 = { r: 168, g: 237, b: 255, a: 255 } as const;
export const maybeBlue100 = { r: 220, g: 244, b: 250, a: 255 } as const;
export const yellove900 = { r: 153, g: 107, b: 0, a: 255 } as const;
export const yellove700 = { r: 255, g: 177, b: 0, a: 255 } as const;
export const yellove500 = { r: 255, g: 208, b: 102, a: 255 } as const;
export const yellove300 = { r: 255, g: 239, b: 204, a: 255 } as const;
export const yellove100 = { r: 255, g: 247, b: 227, a: 255 } as const;
export const redio900 = { r: 102, g: 0, b: 26, a: 255 } as const;
export const redio700 = { r: 235, g: 0, b: 59, a: 255 } as const;
export const redio500 = { r: 255, g: 51, b: 102, a: 255 } as const;
export const redio300 = { r: 255, g: 153, b: 179, a: 255 } as const;
export const redio100 = { r: 255, g: 245, b: 248, a: 255 } as const;
export const base900 = { r: 0, g: 28, b: 36, a: 255 } as const;
export const base800 = { r: 5, g: 37, b: 46, a: 255 } as const;
export const base700 = { r: 24, g: 50, b: 57, a: 255 } as const;
export const base600 = { r: 63, g: 88, b: 95, a: 255 } as const;
export const base500 = { r: 106, g: 124, b: 129, a: 255 } as const;
export const base400 = { r: 149, g: 160, b: 163, a: 255 } as const;
export const base300 = { r: 190, g: 196, b: 198, a: 255 } as const;
export const base200 = { r: 230, g: 233, b: 234, a: 255 } as const;
export const base100 = { r: 247, g: 248, b: 248, a: 255 } as const;
export const base0 = { r: 255, g: 255, b: 255, a: 255 } as const;
export const staticPositive700 = { r: 41, g: 133, b: 90, a: 255 } as const;
export const staticPositive500 = { r: 68, g: 197, b: 137, a: 255 } as const;
export const staticPositive300 = { r: 208, g: 240, b: 225, a: 255 } as const;
export const staticPositive100 = { r: 243, g: 251, b: 248, a: 255 } as const;
export const staticNotice900 = { r: 153, g: 107, b: 0, a: 255 } as const;
export const staticNotice700 = { r: 255, g: 177, b: 0, a: 255 } as const;
export const staticNotice300 = { r: 255, g: 239, b: 204, a: 255 } as const;
export const staticNotice100 = { r: 255, g: 247, b: 227, a: 255 } as const;
export const staticNegative700 = { r: 235, g: 0, b: 59, a: 255 } as const;
export const staticNegative300 = { r: 255, g: 219, b: 228, a: 255 } as const;
export const staticNegative100 = { r: 255, g: 245, b: 248, a: 255 } as const;
export const staticInformative700 = { r: 0, g: 128, b: 163, a: 255 } as const;
export const staticInformative100 = { r: 245, g: 253, b: 255, a: 255 } as const;
export const staticMaybeBlue900 = { r: 0, g: 81, b: 102, a: 255 } as const;
export const staticMaybeBlue700 = { r: 0, g: 128, b: 163, a: 255 } as const;
export const staticMaybeBlue500 = { r: 0, g: 173, b: 219, a: 255 } as const;
export const staticMaybeBlue300 = { r: 168, g: 237, b: 255, a: 255 } as const;
export const staticMaybeBlue100 = { r: 220, g: 244, b: 250, a: 255 } as const;
export const staticYellove900 = { r: 153, g: 107, b: 0, a: 255 } as const;
export const staticYellove700 = { r: 255, g: 177, b: 0, a: 255 } as const;
export const staticYellove500 = { r: 255, g: 208, b: 102, a: 255 } as const;
export const staticYellove300 = { r: 255, g: 239, b: 204, a: 255 } as const;
export const staticYellove100 = { r: 255, g: 247, b: 227, a: 255 } as const;
export const staticRedio900 = { r: 102, g: 0, b: 26, a: 255 } as const;
export const staticRedio700 = { r: 235, g: 0, b: 59, a: 255 } as const;
export const staticRedio500 = { r: 255, g: 51, b: 102, a: 255 } as const;
export const staticRedio300 = { r: 255, g: 153, b: 179, a: 255 } as const;
export const staticRedio100 = { r: 255, g: 245, b: 248, a: 255 } as const;
export const staticBase900 = { r: 0, g: 28, b: 36, a: 255 } as const;
export const staticBase800 = { r: 5, g: 37, b: 46, a: 255 } as const;
export const staticBase700 = { r: 24, g: 50, b: 57, a: 255 } as const;
export const staticBase600 = { r: 63, g: 88, b: 95, a: 255 } as const;
export const staticBase500 = { r: 106, g: 124, b: 129, a: 255 } as const;
export const staticBase400 = { r: 149, g: 160, b: 163, a: 255 } as const;
export const staticBase300 = { r: 190, g: 196, b: 198, a: 255 } as const;
export const staticBase200 = { r: 230, g: 233, b: 234, a: 255 } as const;
export const staticBase100 = { r: 247, g: 248, b: 248, a: 255 } as const;
export const staticBase0 = { r: 255, g: 255, b: 255, a: 255 } as const;
